export type IInventory = {
  _id?: string;
  city: string;
  date: Date;
  situation: INVENTORY_SITUATION;
  total: number;
  vehicles: { licensePlate: string}[];
  updateAt: Date;
}

export enum INVENTORY_SITUATION  {
  IN_PROGRESS = "in_progress", 
  DIVERGENTE = "divergent", 
  DONE = "done"
}

export const emptyInventory = () => ({
  city: "",
  date: new Date(),
  situation: INVENTORY_SITUATION.IN_PROGRESS,
  total: 0,
  vehicles: []
}) as Omit<IInventory, "updateAt">;

export const INVENTORY_STATUS_LABELS = {
  [INVENTORY_SITUATION.DONE]: "Concluído",
  [INVENTORY_SITUATION.IN_PROGRESS]: "Em andamento",
  [INVENTORY_SITUATION.DIVERGENTE]: "Divergente",
};
